import { useQuery } from '@hooks/reactQuery';

import { getKaiAssistants } from '@api/kaiAssistants';

import { extractQueryParams } from '@utils/common';

import { IKaiAssistantDTO } from '@interfaces/kai/dto/kaiDTO';

import { GET_KAI_ASSISTANTS } from '@constants/queryKeys';

export interface IKaiAssistantReturned {
	kaiAssistants: IKaiAssistantDTO[];
	isLoadingKaiAssistants: boolean;
}

export function useQueryKaiAssistants(organisationId?: string): IKaiAssistantReturned {
	const {
		data,
		isLoading,
	} = useQuery<IKaiAssistantDTO[]>({
		queryKey: [GET_KAI_ASSISTANTS, organisationId],
		queryFn: extractQueryParams(getKaiAssistants),
	});

	return {
		kaiAssistants: data || [],
		isLoadingKaiAssistants: isLoading,
	};
}
